export default {
  saveSCORMInteraction(data) {
    const body = {
      messageType: 'assessment',
      interaction: {
        id: data.id,
        type: data.type,
        description: data.description,
        lresponse: data.answer,
        result: data.isCorrect.toString(),
      },
    };
    // eslint-disable-next-line
    return please(window.opener).call('handleScormMessage', JSON.stringify(body));
  },
  saveSCORMQuiz(score, pScore) {
    const fmtScore = Math.round(score);
    const fmtPScore = Math.round(pScore * 100.00);
    const body = {
      messageType: 'score',
      score: {
        min: 0,
        max: 100,
        raw: fmtScore,
      },
      passingscore: fmtPScore,
    };
    // eslint-disable-next-line
    return please(window.opener).call('handleScormMessage', JSON.stringify(body));
  },
};
